import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

const permissionsCollection = collection(db, "permissions");

const permissionService = {
    getAll: async () => {
        try {
            const permissionsSnapshot = await getDocs(permissionsCollection);
            const permissionsList = permissionsSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            return permissionsList;
        } catch (error) {
            console.error('Error fetching permissions:', error);
            throw error;
        }
    },

    getNameById: async (permissionId) => {
      try {
        if (!permissionId) return null;
        
        const permissionRef = doc(db, 'permissions', permissionId);
        const permissionSnap = await getDoc(permissionRef);
  
        return permissionSnap.exists() ? permissionSnap.data().name : null;
      } catch (error) {
        console.error('Error getting permission name:', error);
        return null; // Return null instead of throwing
      }
    },
  
    getIdByName: async (permissionName) => {
      try {
        if (!permissionName) return null;
  
        // Use a query to find the permission by name instead of fetching all permissions
        const q = query(permissionsCollection, where("name", "==", permissionName.trim()));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          return querySnapshot.docs[0].id;
        }
        
        return null;
      } catch (error) {
        console.error('Error getting permission ID:', error);
        return null; // Return null instead of throwing
      }
    }
  };

export default permissionService;